import { Grid2, Box } from "@mui/material";
import Loader from "Components/Common/Loader";
import CommonWrapper from "Components/Common/CommonWrapper";
import ModuleClassDetail from "Components/CoreCurriculum/ModuleClassDetail";
import ModuleInterviewDetail from "Components/CoreCurriculum/ModuleInterviewDetail";
import ModulesList from "Components/CoreCurriculum/ModulesList";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getModules } from "Slices/thunks";


const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  zIndex: 3
});

const CoreCurriculum = () => {
  const { tab } = useParams();
  const dispatch = useDispatch();
  
  const { isLoading } = useSelector((state) => ({
    isLoading: state.Course.loading,
  })); 

  useEffect(() => {
    dispatch(getModules({CourseID: localStorage.getItem("CourseID")}));
  }, [])

  return (
    <CommonWrapper>
      {
        isLoading ? <Loader /> :
          <Grid2 sx={styles}>
            <ModulesList />
            {tab == "interview" ? <ModuleInterviewDetail /> : <ModuleClassDetail />}
          </Grid2>
      }
    </CommonWrapper>
  );
};

export default CoreCurriculum;
